export function buildNonUtilizationFeeClause(fields) {
  if (!fields.nonUtilizationFeeEnabled) {
    return '';
  }
  return String(fields.nonUtilizationFeeWording ?? '').trim();
}

export function buildWarrantsClause(fields) {
  if (!fields.warrantsEnabled) {
    return '';
  }
  return String(fields.warrantsWording ?? '').trim();
}

const TABLE_ROW_PATTERN =
  /<(?:w:|ns0:)tr\b[^>]*>(?:(?!<\/(?:w:|ns0:)tr>)[\s\S])*?<\/(?:w:|ns0:)tr>/g;

function rowPlainText(rowXml) {
  return rowXml.replace(/<[^>]+>/g, '');
}

export function removeTableRowsByLabel(documentXml, label) {
  return documentXml.replace(TABLE_ROW_PATTERN, (row) =>
    rowPlainText(row).includes(label) ? '' : row
  );
}

export function applyOptionalSectionsToDocumentXml(documentXml, fields) {
  let xml = documentXml;
  if (!fields.nonUtilizationFeeEnabled) {
    xml = removeTableRowsByLabel(xml, 'Non-Utilization Fee');
  }
  if (!fields.warrantsEnabled) {
    xml = removeTableRowsByLabel(xml, 'Warrants');
  }
  return xml;
}
